module.exports = __webpack_public_path__ + "static/img/1.93fa31ef.svg";